import React from 'react';
import styles from './footer.module.scss';

export const AppFooter = () => {
  return (
	<div className={styles.footer}>
	  © ФГБНУ Институт стратегии развития образования
	</div>
  );
};
